import { useEffect, useState } from "react";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { ApiError } from "../../../../Error/ApiError";
import { createsTestDatesTableTitle } from "../Data";
import { ColumnDropdown } from "../../../../../components/Dropdownn";
import "../drugTestRandomizer.css";
import axios from "axios";
import { handleGetLocal } from "../../../../../services/auth-service";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { setaddcreatetestdate, setresetcreatetestdate } from "../../../../../reducer/AdminReadReducer";
import { useDispatch } from "react-redux";
import { logOut } from "../../../../../components/Logout";
import { DynamicTabb } from "../../../../../components/DynamicTab/DynamicTab";
import { Toster } from "../../../../../components/Toster/Toster";
import { useScreenPermission } from "../../../../../hooks/useScreenPermission";
import { LoadPanel, Popup } from "devextreme-react";
import { ConfirmRunTestSchedulerPopup } from "./ConfirmRunTestSchedulerPopup";
import { CalendarPlus, PlayCircle } from "lucide-react";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
      />
    </>
  );
};

export const allMonths = [
  { key: "1", value: "January" },
  { key: "2", value: "February" },
  { key: "3", value: "March" },
  { key: "4", value: "April" },
  { key: "5", value: "May" },
  { key: "6", value: "June" },
  { key: "7", value: "July" },
  { key: "8", value: "August" },
  { key: "9", value: "September" },
  { key: "10", value: "October" },
  { key: "11", value: "November" },
  { key: "12", value: "December" },
];

export const genderOptions = [
  { key: "Any", value: "Any" },
  { key: "Male", value: "Male" },
  { key: "Female", value: "Female" },
];

function getISOWeek(date) {
  const startDate = new Date(date.getFullYear(), 0, 1);
  const days = Math.floor((date - startDate) / (24 * 60 * 60 * 1000)) + 1;
  const weekNumber = Math.ceil(days / 7);
  return weekNumber;
}

function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export const CreatesTestDates = () => {
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const { addcreatetestdate, resetcreatetestdate } = useSelector((store) => store.AdminTable);
  const [loading, setLoading] = useState(false);
  const [showSchedulerConfirm, setShowSchedulerConfirm] = useState(false);
  const [schedulerLoading, setSchedulerLoading] = useState(false);
  const [testDateData, setTestDateData] = useState([]);
  const [slotsCount, setSlotsCount] = useState(0);
  const [participantCount, setParticipantCount] = useState(0);
  const [selectedMonthData, setSelectedMonthData] = useState([]);
  const [includeSaturday, setIncludeSaturday] = useState(false);
  const [slotDescriptions, setSlotDescriptions] = useState([]);
  const [runTestSchedulerEnabled, setRunTestSchedulerEnabled] = useState(false);
  const currentYear = new Date().getFullYear();
  const currentMonthID = new Date().getMonth() + 2;
  const currentMonthDate = new Date(currentYear, currentMonthID - 1, 1);
  const currentMonth = currentMonthDate.toLocaleString("default", {
    month: "long",
  });
  const [locationDropdownValues, setLocationDropdownValues] = useState([]);
  const pathname = handleGetLocal("pathURL");

  const [fields, setFields] = useState({
    year: { name: currentYear.toString(), id: currentYear.toString() },
    months: { name: currentMonth, id: currentMonthID },
    gender: { name: genderOptions[0].value, id: genderOptions[0].key },
    location: { name: "", id: "" },
    iSlotLimit: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const SCREEN_NAME = "DT7";
  const { permission, permissionLoading } = useScreenPermission(SCREEN_NAME, navigate);

  const getRunTestSchedulerFlag = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/Account/getCompanyOption?Name=Run Test Scheduler`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setRunTestSchedulerEnabled(
          String(val?.data?.data ?? "")
            .trim()
            .toLowerCase() === "true",
        );
      })
      .catch((error) => {
        setRunTestSchedulerEnabled(false);

        if (error?.response?.status === 401) {
          logOut();
        } else {
          console.error("Error fetching Run Test Scheduler company option:", error);
        }
      });
  };

  const getLocationDropdownValues = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setLocationDropdownValues(val?.data?.data);

        setSlotDescriptions((val?.data?.data?.slotDescriptions || []).filter((item) => item.value?.trim()));
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const yearOptions = Array.from({ length: 10 }, (_, index) => ({
    key: (currentYear + index).toString(),
    value: (currentYear + index).toString(),
  }));

  const updateSelectedMonthData = () => {
    const year = parseInt(fields.year.id, 10);
    const monthIndex = parseInt(fields.months.id, 10) - 1;

    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0);

    setSelectedMonthData((previousData) => {
      const previousSelectionMap = new Map(previousData.map((row) => [row.Date, row]));

      const data = [];

      for (
        let currentDate = new Date(startDate);
        currentDate <= endDate;
        currentDate.setDate(currentDate.getDate() + 1)
      ) {
        const dayOfWeek = currentDate.getDay();

        if (dayOfWeek === 0 || (dayOfWeek === 6 && !includeSaturday)) {
          continue;
        }

        const formattedDate = formatDate(currentDate);

        const previousRow = previousSelectionMap.get(formattedDate);

        data.push({
          Date: formattedDate,
          Day: currentDate.toLocaleDateString("en-US", {
            weekday: "long",
          }),
          "Slot 1": previousRow?.["Slot 1"] ?? false,
          "Slot 2": previousRow?.["Slot 2"] ?? false,
          "Slot 3": previousRow?.["Slot 3"] ?? false,
          "Slot 4": previousRow?.["Slot 4"] ?? false,
          Week: getISOWeek(currentDate),
        });
      }

      return data;
    });
  };

  useEffect(() => {
    updateSelectedMonthData();
  }, [fields.year.id, fields.months.id, includeSaturday]);

  useEffect(() => {
    getLocationDropdownValues();
    getRunTestSchedulerFlag();
    dispatch(setaddcreatetestdate({}));
  }, []);

  const initializeFromLocalStorage = () => {
    const dataWithoutRowId = addcreatetestdate?.rowDataCheck?.map((item) => {
      const { rowId, ...rest } = item;
      return rest;
    });
    setTestDateData(dataWithoutRowId);
    setSlotsCount(addcreatetestdate?.totalCount);
  };

  useEffect(() => {
    initializeFromLocalStorage();
  }, [addcreatetestdate]);

  const divideCount = Number(participantCount) / Number(slotsCount);
  const transformedData = [];

  (testDateData || []).forEach((item) => {
    [1, 2, 3, 4].forEach((slot) => {
      if (item[`Slot ${slot}`]) {
        transformedData.push({
          gEntityID: fields.location.id,
          dTest: item.dTest,
          sGender: fields.gender.id,
          iSlotLimit: Number(fields.iSlotLimit),
          iSlot: slot,
        });
      }
    });
  });
  const handleSave = async () => {
    if (!permission.add) {
      setToastConfig({
        isVisible: true,
        message: "You do not have Add access for DT.7.",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig((prev) => ({
          ...prev,
          isVisible: false,
        }));
      }, 1900);

      return;
    }
    if (!fields.location?.id) {
      setToastConfig({
        isVisible: true,
        message: "Please select Location",
        type: "error",
      });
      setTimeout(() => {
        setToastConfig((prev) => ({
          ...prev,
          isVisible: false,
        }));
      }, 1900);
      return;
    }

    if (!fields.iSlotLimit || Number(fields.iSlotLimit) <= 0) {
      setToastConfig({
        isVisible: true,
        message: "Please enter valid Slot Limit",
        type: "error",
      });
      setTimeout(() => {
        setToastConfig((prev) => ({
          ...prev,
          isVisible: false,
        }));
      }, 1900);
      return;
    }
    setLoading(true);
    const pathname = handleGetLocal("pathURL");
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/add-drug-test-date`, transformedData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setLoading(false);
          setFields({
            year: { name: currentYear.toString(), id: currentYear.toString() },
            months: { name: currentMonth, id: currentMonthID },
            gender: { name: genderOptions[0].value, id: genderOptions[0].key },
            location:
              locationDropdownValues?.location?.length === 1
                ? {
                    name: locationDropdownValues.location[0].value,
                    id: locationDropdownValues.location[0].key,
                  }
                : { name: "", id: "" },
            iSlotLimit: "",
          });
          dispatch(setaddcreatetestdate({}));
          dispatch(setresetcreatetestdate(!resetcreatetestdate));
          updateSelectedMonthData();
          setToastConfig((prev) => ({
            ...prev,
            isVisible: true,
            message: "Test Dates Created",
            type: "success",
          }));
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Test Dates Created",
              type: "success",
            });
          }, 1900);
        } else {
          console.error(val.data.responseMessage);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const handleRunTestScheduler = () => {
    if (schedulerLoading || loading) return;

    setShowSchedulerConfirm(true);
  };

  const confirmRunTestScheduler = () => {
    if (schedulerLoading || loading) return;

    setShowSchedulerConfirm(false);
    setSchedulerLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/run-test-scheduler`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      )
      .then((val) => {
        if (val?.data?.isSuccess) {
          setToastConfig({
            isVisible: true,
            type: "success",
            message: val?.data?.responseMessage || "Drug Test Scheduler completed successfully.",
          });
        } else {
          setToastConfig({
            isVisible: true,
            type: "error",
            message: val?.data?.responseMessage || "Unable to run Drug Test Scheduler.",
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          logOut();
          return;
        }

        setToastConfig({
          isVisible: true,
          type: "error",
          message: error?.response?.data?.responseMessage || "An error occurred while running Drug Test Scheduler.",
        });
      })
      .finally(() => {
        setSchedulerLoading(false);

        setTimeout(() => {
          setToastConfig((prev) => ({
            ...prev,
            isVisible: false,
          }));
        }, 3000);
      });
  };

  useEffect(() => {
    const locations = Array.isArray(locationDropdownValues?.location) ? locationDropdownValues.location : [];

    // No locations available
    if (locations.length === 0) {
      setFields((prevFields) => ({
        ...prevFields,
        location: { name: "", id: "" },
      }));
      return;
    }

    // Only one location - automatically select it
    if (locations.length === 1) {
      setFields((prevFields) => ({
        ...prevFields,
        location: {
          name: locations[0].value,
          id: locations[0].key,
        },
      }));
      return;
    }

    // Multiple locations - select saved location if available
    const filteredLocation = locations.find((item) => item.value === localStorage.getItem("location"));

    setFields((prevFields) => ({
      ...prevFields,
      location: filteredLocation
        ? {
            name: filteredLocation.value,
            id: filteredLocation.key,
          }
        : { name: "", id: "" },
    }));
  }, [locationDropdownValues]);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading || schedulerLoading || permissionLoading} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <ConfirmRunTestSchedulerPopup
        visible={showSchedulerConfirm}
        onClose={() => setShowSchedulerConfirm(false)}
        onConfirm={confirmRunTestScheduler}
        loading={schedulerLoading}
      />
      {!permission.view ? (
        <div style={{ padding: "20px", fontWeight: 600 }}>You do not have View access for DT.7.</div>
      ) : (
        <div className="page-content" style={{ margin: "20px 0", padding: "20px", background: "white" }}>
          <br />
          <DynamicTabb />
          <br />
          <p className="page-info-number">DT.7</p>
          <br />
          <div className="dt7-filter-container">
            <div className="dt7-action-buttons">
              <button
                type="button"
                className="dt7-action-btn dt7-generate-action"
                disabled={!permission.add || loading || schedulerLoading}
                onClick={handleSave}
              >
                <CalendarPlus size={17} strokeWidth={2} />
                <span>Generate</span>
              </button>

              {runTestSchedulerEnabled && (
                <button
                  type="button"
                  className="dt7-action-btn dt7-scheduler-action"
                  disabled={!permission.add || loading || schedulerLoading}
                  onClick={handleRunTestScheduler}
                >
                  <PlayCircle size={17} strokeWidth={2} />
                  <span>Run Test Scheduler</span>
                </button>
              )}
            </div>

            <div className="dt7-filter-grid">
              <div className="dt7-filter-field">
                <label className="edit_container_label">Location</label>
                <div className="dt7-dropdown">
                  <DropDown
                    setfields={setFields}
                    fields={fields}
                    fieldNmae="location"
                    dropDownData={locationDropdownValues?.location?.map((vall) => ({
                      name: vall?.value,
                      id: vall?.key,
                    }))}
                  />
                </div>
              </div>
              <div className="dt7-filter-field">
                <label className="edit_container_label">Year</label>
                <div className="dt7-dropdown">
                  <DropDown
                    setfields={setFields}
                    fields={fields}
                    fieldNmae="year"
                    dropDownData={yearOptions?.map((vall) => ({
                      name: vall?.value,
                      id: vall?.key,
                    }))}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="dt7-saturday-field">
                <label htmlFor="includeSaturday" className="edit_container_label">
                  Include Saturday
                </label>
                <input
                  type="checkbox"
                  id="includeSaturday"
                  checked={includeSaturday}
                  onChange={(e) => setIncludeSaturday(e.target.checked)}
                />
              </div>
              <div className="dt7-filter-field">
                <label className="edit_container_label">Gender</label>
                <div className="dt7-dropdown">
                  <DropDown
                    setfields={setFields}
                    fields={fields}
                    fieldNmae="gender"
                    dropDownData={genderOptions?.map((vall) => ({
                      name: vall?.value,
                      id: vall?.key,
                    }))}
                  />
                </div>
              </div>
              <div className="dt7-filter-field">
                <label className="edit_container_label">Month</label>
                <div className="dt7-dropdown">
                  <DropDown
                    setfields={setFields}
                    fields={fields}
                    fieldNmae="months"
                    dropDownData={allMonths?.map((vall) => ({
                      name: vall?.value,
                      id: vall?.key,
                    }))}
                  />
                </div>
              </div>
              <div className="dt7-filter-field dt7-slot-field">
                <label className="edit_container_label">Slot Limit</label>
                <input
                  type="number"
                  name="iSlotLimit"
                  id="iSlotLimit"
                  placeholder="Slot Limit"
                  value={fields.iSlotLimit}
                  onChange={handleInputChange}
                  className="fee-payment-content-info-input dt7-slot-input"
                />
              </div>
            </div>
          </div>
          {slotDescriptions.length > 0 && (
            <div className="dt7-slot-descriptions">
              {slotDescriptions.map((slot) => (
                <div key={slot.key} className="dt7-slot-description">
                  <strong>{slot.key.replace("DTR ", "").replace(" Description", "")}:</strong>
                  <span>{slot.value}</span>
                </div>
              ))}
            </div>
          )}
          <p className="go-to-label-filed">
            {slotsCount > 0
              ? `Participant: ${participantCount}, Slots: ${slotsCount}, Participant/Slot : ${divideCount}`
              : ""}
          </p>
          <br />
          <div className="flex-frame-content">
            <div className="drug-test-schedule">
              <Table1
                isTestDateGrid={true}
                editTable={false}
                height={"auto"}
                Tablecoloum={createsTestDatesTableTitle}
                tableRow={selectedMonthData?.map((val) => {
                  return {
                    ...val,
                    ID: val.Date,
                  };
                })}
                load={loading}
                coloumWidthText={"Creates-Test-Dates"}
                mandatoryColoum={"Date"}
                createTestFieldData={fields}
                setSlotsCount={setSlotsCount}
                showAllRows={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
